// Internal modules
import { getGlobals, getLocale } from '@/lib';

const cache = {};

const getMemoOccupationSelections = () => {
  const key = getLocale().locale;
  if (cache[key]) {
    return cache[key];
  }
  const occupations = getGlobals().content.occupationList;
  const occupationSelections = Object.entries(occupations).map(
    ([propName, text]) => ({
      key: propName,
      text,
      value: propName,
    }),
  );
  cache[key] = occupationSelections;
  return occupationSelections;
};

export { getMemoOccupationSelections };
